<div class="Wizard w-100">
  <div *ngIf="showStepper" class="Wizard-header">
    <ul class="timeline">
      <li
        *ngFor="let step of steps; let i = index"
        [class.pending]="currentStepIndex < i"
        [attr.data-tile]="step.title">
        <span *ngIf="currentStepIndex <= i">{{ i + 1 }}</span>
        <span *ngIf="currentStepIndex > i"
          ><fa-icon [icon]="iconCheck"></fa-icon
        ></span>
      </li>
    </ul>
  </div>
  <div class="Wizard-body" [@animSlider]="currentStepIndex">
    <div *ngIf="!validationInProgress; else spinner">
      <div
        *ngIf="
          stepErrors[currentStepIndex] &&
          stepErrors[currentStepIndex].length > 0
        ">
        <div
          *ngFor="let error of stepErrors[currentStepIndex]"
          class="alert alert-danger alert-dismissible fade show"
          role="alert">
          <span>{{ error }}</span>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"></button>
        </div>
      </div>
      <ng-container *ngFor="let step of steps; let i = index">
        <div *ngIf="i === currentStepIndex">
          <app-dcl
            [providers]="dcpProviders"
            (ref)="onComponentRef($event, step, i)"
            *ngIf="isComponent(step.component)"
            [component]="step.component"
            [data]="step.componentData"></app-dcl>
        </div>
      </ng-container>
    </div>
    <ng-template #spinner>
      <mat-card
        style="display: flex; justify-content: center; align-items: center">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </mat-card>
    </ng-template>
  </div>
</div>
